import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService, fromMinutesToMilliseconds, fromSecondsToMilliseconds } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class DgaAuthTransactionConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getVerificationStatusEndpoint(): string {
		return this.service.get(
			(x) => x.core.dgaAuthTransaction.endpoints!.verificationStatus,
			"v2/authentication-transaction/status"
		);
	}

	getVerificationEndpoint(): string {
		return this.service.get(
			(x) => x.core.dgaAuthTransaction.endpoints!.verification,
			"v2/authentication-transaction"
		);
	}

	getVerificationStatusInterval(): number {
		return this.service.get(
			(x) => x.core.dgaAuthTransaction.verificationStatusInterval,
			fromSecondsToMilliseconds(1.5)
		);
	}

	getVerificationStatusTimeout(): number {
		return this.service.get(
			(x) => x.core.dgaAuthTransaction.verificationStatusTimeout,
			fromMinutesToMilliseconds(3)
		);
	}

	getExperianDataEndpoint(): string {
		return this.service.get((x) => x.core.dgaAuthTransaction.endpoints!.experianData, "v1/dk/personaldata");
	}

	getOpenIdConnectUrlEndpoint(): string {
		return this.service.get((x) => x.core.dgaAuthTransaction.endpoints?.openIdConnect, "v1/oidc-uris");
	}
}
